import axios from "axios";

const setAuthToken = jwtToken => {
  if (jwtToken) {
    // Apply to every request
    axios.defaults.headers.common.Authorization = `Bearer ${jwtToken}`;
  } else {
    // Delete auth header
    delete axios.defaults.headers.common.Authorization;
  }
};

export default setAuthToken;
